export default function normalizePhoneNumber(countryCode, phoneNumber) {
  let normalizedCountryCode = (`${countryCode}`.charAt(0) === '+') ? `${countryCode}`.substring(1) : `${countryCode}`;
  normalizedCountryCode = (`${normalizedCountryCode}`.charAt(normalizedCountryCode.length - 1) === '0') ? `${normalizedCountryCode}`.substring(0, normalizedCountryCode.length - 1) : `${normalizedCountryCode}`;

  let normalizedPhoneNumber = (`${phoneNumber}`.charAt(0) === '0') ? `${phoneNumber}`.substring(1) : `${phoneNumber}`;
  normalizedPhoneNumber = (`${countryCode}`.charAt(countryCode.length - 1) === '0') ? `0${normalizedPhoneNumber}` : `${normalizedPhoneNumber}`;

  return `+${normalizedCountryCode} (${normalizedPhoneNumber.substring(0, 3)}) ${normalizedPhoneNumber.substring(3, 6)}-${normalizedPhoneNumber.substring(6)}`;
}
